import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

function Lightswitch({
  isToggledOn = false, textLeft, textRight, toggleHandler,
}) {
  const highlightRef = useRef(null);
  const textLeftRef = useRef(null);
  const textRightRef = useRef(null);

  const [toggledOn, setToggledOn] = useState(isToggledOn);

  useEffect(() => {
    const getWidth = (ref) => `${ref.current.getBoundingClientRect().width}px`;

    if (toggledOn) {
      highlightRef.current.style.transform = `translateX(${getWidth(textLeftRef)})`;
      highlightRef.current.style.width = getWidth(textRightRef);
    } else {
      highlightRef.current.style.transform = 'translateX(0)';
      highlightRef.current.style.width = getWidth(textLeftRef);
    }
  }, [textLeftRef.current, textRightRef.current, toggledOn]);

  const handleToggle = () => {
    setToggledOn(!toggledOn);

    toggleHandler();
  };

  return (
    <div
      aria-checked={toggledOn}
      className="c-lightswitch"
      onClick={handleToggle}
      onKeyDown={handleToggle}
      role="switch"
      tabIndex={0}
    >
      <div className="c-lightswitch__highlight" ref={highlightRef} />

      <span className="c-lightswitch__text" ref={textLeftRef}>{textLeft}</span>
      <span className="c-lightswitch__text" ref={textRightRef}>{textRight}</span>
    </div>
  );
}

Lightswitch.propTypes = {
  isToggledOn: PropTypes.bool,
  textLeft: PropTypes.string.isRequired,
  textRight: PropTypes.string.isRequired,
  toggleHandler: PropTypes.func.isRequired,
};

export default Lightswitch;
